import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services';



// user connected and try go to auth root
export const AuthGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['auth']);
    return false;
  }
}

// user not connected and try to go page route
export const NotAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['pages']);
    return false;
  }
}
